/* eslint-disable react-hooks/exhaustive-deps */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";

import { PageHeaderName } from "../../StyledCss/styledComponents";
import {
  getAdmins,
  getWorkRequests,
  updateExtraWork,
} from "../../api/services/hroneApi";
import formatDate from "../../util/formatdate";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import "../CommonCss/slidingModal.css";
import ExtraWorkRejectForm from "../ExtraWorkReject/extraWorkReject";
import Extraworkform from "../ExtraworkForm";
import ExtraworkHistory from "../ExtraworkHistory";
import FailureView from "../FailureView";
import Header from "../Header";
import LeftNavBar from "../LeftNavBar";
import LoadingView from "../LoadingView";
import PageHeader from "../PageHeader";
import PopupModal from "../PopupModal";
import ReimbursementHistory from "../ReimbursementHistory";
import "./index.css";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const Reimbursement = () => {
  const { hasPermission } = usePermissions();
  const canApplyExtraWork = hasPermission(FEATURE_CODES.REIMBURSEMENT_CREATE);
  const canApproveRequests = hasPermission(FEATURE_CODES.REIMBURSEMENT_APPROVE);
  // REIMBURSEMENT_REQUESTS_VIEW / REIMBURSEMENT_REJECT are new, separately
  // grantable permissions (not yet seeded on the backend — see featureCodes.js).
  // Until a role is explicitly given one of these, fall back to the legacy
  // REIMBURSEMENT_APPROVE permission so nobody who can approve today loses the
  // Requests tab or the Reject button once these checks are added.
  const canRejectRequests =
    hasPermission(FEATURE_CODES.REIMBURSEMENT_REJECT) || canApproveRequests;
  const canViewRequestsTab =
    hasPermission(FEATURE_CODES.REIMBURSEMENT_REQUESTS_VIEW) ||
    canApproveRequests ||
    canRejectRequests;
  const canViewAllHistory = hasPermission(FEATURE_CODES.REIMBURSEMENT_VIEW_ALL);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refetchData, setRefetchData] = useState(false);
  const [extraWorkingHoursData, setExtraHoursData] = useState([]);
  const [rejectClicked, setReject] = useState(false);
  const [activeTab, setActiveTab] = useState("Your History");
  const [approvalApiStatus, setApprovalApiStatus] = useState(
    apiStatusConstants.initial
  );
  const [rowData, setRowData] = useState({});
  const [hrList, setHrList] = useState([]);

  const date = new Date();
  const [startMonth, setStartMonth] = useState(date);
  const notifyApproved = () => toast.success("Reimbursement Approved");

  const notifySuccess = () => toast.success("Extra work Applied Successfully");

  const notifyFailure = () => toast.error("something went wrong");

  useEffect(() => {
    getPendingRequestsData();
  }, [activeTab === "Requests"]);
  const getPendingRequestsData = async () => {
    setApiStatus(apiStatusConstants.inProgress);

    try {
      const responsehrList = await getAdmins();

      if (responsehrList.status === 200) {
        const hrData = await responsehrList.json();

        setHrList(hrData);
      }

      // Only the "Requests" tab needs the pending list — skip it for everyone
      // else so a 403 here can't stall the whole page's load state for roles
      // that don't have that permission.
      if (canViewRequestsTab) {
        const response = await getWorkRequests();
        if (response.status === 200) {
          const data = convertKeysToCamelCase(await response.json());
          const updatedData = data.map((eachWork) => ({
            ...eachWork,
            date: formatDate(eachWork.date),
          }));

          setExtraHoursData(updatedData);
        }
      }

      setApiStatus(apiStatusConstants.success);
    } catch (error) {
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const sendAcceptedStatus = async (params) => {
    setApprovalApiStatus(apiStatusConstants.inProgress);
    const workId = params.data.extraWorkId;
    const status = "Approved";
    const rejectedReason = params.data.rejectedReason;
    const response = await updateExtraWork(workId, status, rejectedReason);
    try {
      if (response.status === 200) {
        notifyApproved();
        setTimeout(() => {
          getPendingRequestsData();
          setApprovalApiStatus(apiStatusConstants.success);
        }, 500);
      } else {
        notifyFailure();
      }
    } catch (error) {
      notifyFailure();
    }
  };

  const onClickApprove = (params) => {
    sendAcceptedStatus(params);
  };

  const onClickReject = (params) => {
    const rowData = params.data;
    setRowData({ ...rowData, status: "Rejected" });
    setReject(!rejectClicked);
  };

  const onClickClose = () => {
    setReject(false);
  };

  const renderReimbursementRequests = () => {
    const paginationPageSize = 20;
    const columnDefs = [
      {
        headerName: "EMP ID",
        field: "employeeId",
        width: 120,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "NAME",
        valueGetter: function (params) {
          const firstName = params.data.firstName;
          const lastName = params.data.lastName;
          const combinedData = firstName + " " + lastName;
          return combinedData;
        },

        filter: true,
        floatingFilter: true,
        sortable: true,
        suppressMenu: true
      },
      {
        headerName: "DATE",
        field: "date",
        width: 130,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "HOURS WORKED",
        field: "hours",
        width: 180,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      {
        headerName: "STATUS",
        field: "status",
        width: 150,
        filter: true,
        floatingFilter: true,
        suppressMenu: true
      },
      ...(canApproveRequests
        ? [
            {
              headerName: "APPROVE",
              cellRenderer: (params) => (
                <PrimaryButton
                  disabled={approvalApiStatus === apiStatusConstants.inProgress}
                  className="d-flex  justify-content-center align-items-center"
                  onClick={() => onClickApprove(params)}
                >
                  Approve
                </PrimaryButton>
              ),
            },
          ]
        : []),
      ...(canRejectRequests
        ? [
            {
              headerName: "REJECT",
              cellRenderer: (params) => (
                <SecondaryButton
                  className="d-flex  justify-content-center align-items-center"
                  onClick={() => onClickReject(params)}
                >
                  Reject
                </SecondaryButton>
              ),
            },
          ]
        : []),
    ];

    return (
      <div
        className="ag-theme-alpine"
        style={{
          height: "75vh",
          fontSize: "14px",
          marginLeft: "20px",
          marginRight: "20px",
          marginTop: "20px",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <AgGridReact
          title="All Resources"
          columnDefs={columnDefs}
          rowData={extraWorkingHoursData}
          pagination={true}
          paginationPageSize={paginationPageSize}
          enableCellTextSelection={true}
          // defaultColDef={defaultColDef}
        ></AgGridReact>
      </div>
    );
  };

  const handleApplyExtra = () => {
    setIsModalOpen(true);
    setRefetchData(false);
  };
  const closeBtn = () => {
    setIsModalOpen(false);
  };

  const extraworkApplied = () => {
    setIsModalOpen(false);
    setRefetchData(true);
  };

  const applyExtraWork = () => (
    <div>
      <div className="d-flex flex-row flex-wrap justify-content-end mb-1 align-items-center">
        <div className="d-flex flex-column m-1">
          <div className="me-3">
            <label className="mb-1">Select Month</label>
            <DatePicker
              className="date-input-label"
              selected={startMonth}
              onChange={(date) => {
                if (date) {
                  setStartMonth(date);
                } else {
                  setStartMonth(new Date());
                }
              }}
              showMonthYearPicker
              dateFormat="MMMM yyyy"
            />
          </div>
        </div>
      </div>

      <div className="extra-work-history-div">
        <ExtraworkHistory startMonth={startMonth} refetchData={refetchData} />
      </div>
    </div>
  );

  const pageTabsList = [
    {
      id: 1,
      name: "Your History",
      isVisible: true,
    },
    {
      id: 2,
      name: "Requests",
      isVisible: canViewRequestsTab,
    },
    {
      id: 3,
      name: "All History",
      isVisible: canViewAllHistory,
    },
  ];

  const orgDetails = JSON.parse(localStorage.getItem("org"));
  const { primaryColor } = orgDetails;

  const tabs = () => {
    return pageTabsList.map(
      (eachTab) =>
        eachTab.isVisible && (
          <button
            style={
              activeTab === eachTab.name
                ? {
                    color: primaryColor,
                    borderBottom: `3px solid ${primaryColor}`,
                  }
                : {}
            }
            className={
              activeTab === eachTab.name
                ? "reimbursement-active-tab"
                : "reimbursement-tab"
            }
            onClick={() => setActiveTab(eachTab.name)}
            key={eachTab.id}
          >
            {eachTab.name}
          </button>
        )
    );
  };

  const renderReimbursementPage = () => {
    switch (activeTab) {
      case "Your History":
        return applyExtraWork();
      case "Requests":
        return renderReimbursementRequests();
      case "All History":
        return <ReimbursementHistory />;
      default:
        return null;
    }
  };
  const onClickRetry = () => {
    getPendingRequestsData();
  };

  const renderReimbursement = () => {
    switch (apiStatus) {
      case apiStatusConstants.success:
        return renderReimbursementPage();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={onClickRetry} />;
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Header />
      <div className="d-flex">
        <LeftNavBar />
        <div className="page-content-wrapper">
          <PageHeader>
            <PageHeaderName>Reimbursement</PageHeaderName>
            {canApplyExtraWork && (
              <div className="extra-btn-div" style={{ marginRight: "18px" }}>
                <PrimaryButton onClick={handleApplyExtra} type="button">
                  Apply Extra Work
                </PrimaryButton>
              </div>
            )}
          </PageHeader>

          <div className="reimbursement-tabs-container">
            <div>{tabs()}</div>
            {renderReimbursement()}
          </div>
        </div>
      </div>

      <PopupModal
        modalName="Apply Reimbursement"
        closeBtn={closeBtn}
        showModal={isModalOpen}
      >
        <Extraworkform
          hrList={hrList}
          closeBtn={closeBtn}
          extraworkApplied={extraworkApplied}
          notifySuccess={notifySuccess}
        />
      </PopupModal>

      {/* <SlidingModal
        modalName="Apply Reimbursement"
        closeBtn={closeBtn}
        isModalOpen={isModalOpen}
      ></SlidingModal> */}

      <PopupModal
        modalName="Reject Work"
        closeBtn={onClickClose}
        showModal={rejectClicked}
      >
        <ExtraWorkRejectForm
          rowData={rowData}
          setReject={setReject}
          getPendingRequestsData={getPendingRequestsData}
          closeBtn={onClickClose}
        />
      </PopupModal>
      {/* <SlidingModal
        closeBtn={onClickClose}
        isModalOpen={rejectClicked}
      ></SlidingModal> */}
    </div>
  );
};

export default Reimbursement;
